import React, { FC } from 'react';
import styled from 'styled-components';

import PlayArrow from 'crehana-icons/PlayArrow';

import { useTranslation } from 'Shared/Hooks/useTranslation';
import getImgxUrl from 'Jsx/Utils/getImgxUrl';

import locales from '../i18n/localeEs';

const translations = locales.es;

type ImageProps = {
  coverUrlTablet: string;
  coverUrlMobile: string;
};

const Image = styled.div<ImageProps>`
  height: 190px;
  background-image: url(${props => props.coverUrlMobile});
  background-size: cover;
  background-position: top;
  @media (min-width: 420px) {
    height: 244px;
    background-image: url(${props => props.coverUrlTablet});
  }
`;

const Opacity = styled.div`
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 49.48%,
    rgba(0, 0, 0, 0.5) 100%
  );
`;

type CourseCoverProps = {
  coverUrl: string;
  showCourseTrailer(): void;
  coverPlaceholder?: string;
};

const CourseCover: FC<CourseCoverProps> = ({ coverUrl, showCourseTrailer }) => {
  const { t } = useTranslation();

  const mobileImage = getImgxUrl(coverUrl, {
    auto: 'format',
    w: 420,
    h: 190,
    q: 70,
    crop: 'faces',
  });
  const tabletImage = getImgxUrl(coverUrl, {
    auto: 'format',
    w: 768,
    h: 244,
    q: 70,
    crop: 'faces',
  });

  return (
    <button
      type="button"
      className="block md:hidden relative mb-24 sm:mb-40 w-full"
      onClick={showCourseTrailer}
    >
      <Image
        className="relative z-1 block w-full"
        coverUrlTablet={tabletImage}
        coverUrlMobile={mobileImage}
      />
      <Opacity className="z-2 absolute w-full h-full top-0 left-0 flex items-center justify-center">
        <div className="flex flex-col items-center">
          <PlayArrow size={40} color="#ffffff" />
          <p className="mt-24 font-link text-white">
            {t('WATCH_TRAILER', {
              defaultValue: translations.WATCH_TRAILER,
            })}
          </p>
        </div>
      </Opacity>
    </button>
  );
};

export default CourseCover;
